import {
  useWorkflowTwo,
  generateWfTwoPdfReportbyId,
} from "../../../../../libs/apis";
import { ShowContainer } from "../../../../../components/workflow-two/components/list/show-container";
import { WorkflowProcessTable } from "./workflow-process-table";

const useWorkflowTwoList = (params: Parameters<typeof useWorkflowTwo>[0]) =>
  useWorkflowTwo(params).workflowTwosQuery;

const WorkflowTwoListComponent = () => (
  <WorkflowProcessTable
    useList={useWorkflowTwoList}
    generatePdf={generateWfTwoPdfReportbyId}
    type="two"
    number={2}
    ShowContainer={ShowContainer}
  />
);

export default WorkflowTwoListComponent;
